var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Title'),_c('VideoModals'),_c('FeaturedCategories'),_c('ShowcaseProducts',{attrs:{"products":_vm.products,"titleBox":_vm.translateTitleBox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }